<template>
  <div class="base">
    <Header :current-view="currentView" />
    <BreadCrumb :current-view="currentView" />
    <div class="main">
      <transition
        name="slide-fade"
        mode="out-in"
      >
        <router-view :key="$route.name" />
      </transition>
    </div>
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/common/Header.vue';
import Footer from '@/components/common/Footer.vue';
import BreadCrumb from '@/components/common/BreadCrumb.vue';

 // Mixin
import autoLogin from '@/mixins/autoLoginMixin';

export default {
  name: 'Default',

  components: {
    Header,
    Footer,
    BreadCrumb
  },

  mixins: [ autoLogin ],

  provide: {
    footerless: false
  },

  data(){
    return {
      currentView: 'Home',
    };
  },

  async created(){
    this.appendScript();
  },

  mounted(){
    this.currentView = this.$router.history.current.name;
  },
  updated(){
    this.currentView = this.$router.history.current.name;
  },
  methods: {
    appendScript() {
      const recaptcha = document.createElement('script');

      recaptcha.setAttribute('type', 'text/javascript');
      recaptcha.setAttribute('src', `https://www.google.com/recaptcha/api.js?render=${process.env.VUE_APP_RECAPTCHA_SITE_KEY}`);

      document.querySelector('body').appendChild(recaptcha);

    },
  },
};
</script>

<style lang="scss" scoped>
  .base {
    height: 100%;
    width: 100vw;
    background-color: $gray-bg;
  }

  .main {
    width: 100%;
    padding: 0 4%;

    @include screen(tablet-big-up) {
      min-height: calc(100vh - 21.375rem);
      padding: 0 8%;
    }
  }
</style>
